import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { SeoToolsApiService } from '../../services/seotools-api.service';

@Component({
  selector: 'app-meta-description-checker',
  templateUrl: './meta-description-checker.component.html',
  styleUrl: './meta-description-checker.component.css'
})
export class MetaDescriptionCheckerComponent {
  url = ""
  seoResults: any
  showCheckSeoModalSpinner = false
  showMessage = false;
  message = "";
  alertType: number = 1;

  constructor(@Inject(DOCUMENT) private document: Document, private titleService: Title, private meta: Meta, private seoToolsApiService: SeoToolsApiService,) {
    this.titleService.setTitle("Meta Description | RankAhead");
    this.meta.addTag({
      name: 'description',
      content: 'Use our free meta description checker tool to check and optimize your meta description to make it SEO friendly.'
    });
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');
  }

  showAlert(alertType: number, message: string) {
    this.alertType = alertType;
    this.message = message;
    this.showMessage = true;

    setTimeout(() => {
      this.showMessage = false;
      this.message = "";
    }, 5000);
  }

  checkMetaDescription() {
    this.seoResults = null;
    this.showCheckSeoModalSpinner = true;

    this.seoToolsApiService.checkSeo(this.url, 2).subscribe(response => {
      this.seoResults = response;
      this.showCheckSeoModalSpinner = false;
    }, (error: any) => {
      this.showCheckSeoModalSpinner = false;
      this.showAlert(0, "An error occured while retrieving results.");
    })
  }
}
